import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-unauthorized",
  templateUrl: "unauthorized.component.html",
})
export class UnauthorizedComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    //this._authService.login();
  }
}
